import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import { roles } from "../../../utils/helperFunction";
import { adminRoles } from "../../../utils/constants";
const ProtectedRouteAdmin = ({ permission, children }) => {
  const { access_token, role } = useSelector((state) => state.AUTH);
  const permissions = useSelector(
    (state) => state?.LOGIN?.LoginData?.data?.permissions || []
  );

  const {
    distributor_super_admin,
    distributor_user,
    distributor_salesrepresentative,
  } = roles;

  const isAllowed =
    _.some(permission, (permission) => permissions.includes(permission)) &&
    adminRoles.includes(role);
  if (!access_token) {
    return <Navigate to="/login" />;
  }
  if (isAllowed) {
    return children;
  } else if (
    !isAllowed &&
    role !== distributor_super_admin &&
    role !== distributor_user &&
    role !== distributor_salesrepresentative
  ) {
    return <Navigate to="/" />;
  } else {
    return <Navigate to="/distributor" />;
  }
};

export default ProtectedRouteAdmin;
